<template>
    <div class="board-log">
        <!-- 查询段 -->
        <div class="query-box mb10">
            <el-form inline :model="formData" size="mini" class="filter-bar">
                <!-- 工单筛选（2026-07-31 三期 §三；2026-08-03 按需求方要求改回纯输入框）
                     ⚠️ 这里**不用** OrderProjectFilter widget：本页只要「一个工单搜索框」，
                        不要批量粘贴/远程多选那套，也不要 widget 自带的红叉（本筛选项固定、不可删除）。
                        与「关键词/动作/操作人/时间」同款 CustomInput 包装，形态保持一致。 -->
                <el-form-item>
                    <CustomInput label="工单">
                        <el-input v-model="formData.work_order" placeholder="工单ID/名称" clearable size="mini" style="width:160px"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="关键词">
                        <el-input v-model="formData.search" placeholder="工单名/详情" clearable size="mini" style="width:160px"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="动作">
                        <SelectAll :options="actionOptions" v-model="formData.action" :multiple="false" placeholder="全部"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="操作人">
                        <SelectAll :options="operatorOptions" v-model="formData.operator_uid" :multiple="false" placeholder="全部"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="时间">
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" size="mini"
                                        range-separator="至" start-placeholder="起" end-placeholder="止" style="width:230px"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                    <el-button size="mini" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 子tab栏（查询卡下方、表格上方，由容器传入） -->
        <ObliqueTags v-if="tabTags.length" :tags="tabTags" :value="activeTab" @tab-click="v=>$emit('tab-switch', v)"/>

        <!-- 表格段 -->
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <el-button size="mini" icon="el-icon-refresh" @click="getList">刷新</el-button>
                    <span class="op-tip">排单全流程动作流水：自动预排 / 换组 / 改交付日 / 调优先级 / 置换 / 确认 / 定版 / 审批 / 特殊产能 / 改排期 / 排单清理 / 撤回 / 驳回</span>
                </div>
            </div>

            <jt-table v-loading="loading" :data="list" border stripe header-cell-class-name="header-cell" style="width:100%">
                <el-table-column label="时间" align="center" width="150">
                    <template slot-scope="{row}">{{ fmtTime(row.ctime) }}</template>
                </el-table-column>
                <el-table-column label="动作" align="center" width="100">
                    <template slot-scope="{row}">
                        <el-tag size="mini" :type="actionTagType(row.action)" effect="plain">{{ actionText(row.action) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="工单 / 项目" align="left" min-width="180">
                    <template slot-scope="{row}">
                        <div class="oname">#{{row.order_id}} {{row.order_name||'—'}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" align="center" width="100">
                    <template slot-scope="{row}">{{ row.operator_name || (row.operator_uid==0 ? '系统' : row.operator_uid) || '—' }}</template>
                </el-table-column>
                <el-table-column label="详情" align="left" min-width="220" class-name="ec-reason">
                    <template slot-scope="{row}">{{ row.content || '—' }}</template>
                </el-table-column>
            </jt-table>

            <div class="tar mt10">
                <el-pagination background layout="total, prev, pager, next, sizes" :total="total"
                               :current-page="formData.page" :page-size="formData.page_size" :page-sizes="[20,50,100]"
                               @current-change="onPageChange" @size-change="onSizeChange"/>
            </div>
        </div>
    </div>
</template>

<script>
    import API from '@/api/workOrder/scheduleManage.js';
    import SelectAll from '@/components/SelectAll';
    import ObliqueTags from '@/views/workOrder/components/obliqueTags.vue';
    // CustomInput 是全局注册的，无需 import

    export default {
        name: 'BoardLog',
        components: { SelectAll, ObliqueTags },
        props: {
            tabTags: { type: Array, default: () => [] },
            activeTab: { type: String, default: '' },
        },
        data() {
            return {
                loading: false,
                list: [],
                total: 0,
                dateRange: [],
                actionMap: {},
                actionOptions: [],
                operatorOptions: [],
                formData: this.defaultForm(),
            };
        },
        mounted() {
            this.loadOptions();
            this.getList();
        },
        methods: {
            defaultForm() {
                return { page: 1, page_size: 20, search: '', action: '', operator_uid: '', work_order: '', date_from: '', date_to: '' };
            },
            actionText(v) { return this.actionMap[v] || ('动作' + v); },
            actionTagType(v) {
                if ([7].indexOf(Number(v)) > -1) return 'success';     // 定版
                if ([5, 8, 9].indexOf(Number(v)) > -1) return 'warning'; // 置换/审批/特殊产能
                if ([1].indexOf(Number(v)) > -1) return 'info';        // 自动预排
                return '';
            },
            fmtTime(sec) {
                if (!sec) return '—';
                const d = new Date(sec * 1000);
                const p = n => (n < 10 ? '0' + n : '' + n);
                return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
            },
            async loadOptions() {
                try {
                    const { data } = await API.getLogOptions({});
                    this.actionOptions = (data.action || []).map(o => ({ value: o.v, label: o.name }));
                    (data.action || []).forEach(o => { this.actionMap[o.v] = o.name; });
                    this.operatorOptions = (data.operator || []).map(o => ({ value: o.v, label: o.name || o.v }));
                } catch (e) { /* ignore */ }
            },
            async getList() {
                this.loading = true;
                this.formData.date_from = (this.dateRange && this.dateRange[0]) || '';
                this.formData.date_to = (this.dateRange && this.dateRange[1]) || '';
                // work_order 直接就是输入框里的字符串：服务端按「纯数字 → l.order_id 精确；否则 → o.order_name 模糊」分辨。
                try {
                    const { data } = await API.getLogList({ ...this.formData });
                    this.list = data.list || [];
                    this.total = data.total || 0;
                } catch (error) {
                    this.$message.error((error && error.info) || '加载失败');
                } finally {
                    this.loading = false;
                }
            },
            handleSearch() { this.formData.page = 1; this.getList(); },
            handleReset() {
                const ps = this.formData.page_size;
                this.formData = { ...this.defaultForm(), page_size: ps };
                this.dateRange = [];
                this.getList();
            },
            onPageChange(p) { this.formData.page = p; this.getList(); },
            onSizeChange(s) { this.formData.page_size = s; this.formData.page = 1; this.getList(); },
        },
    };
</script>

<style scoped lang="scss">
    @import "~@/styles/material_sd.scss";

    .board-log { padding: 4px 0; }
    .query-box { background: #fff; padding: 20px 10px; border-radius: 4px; }
    .query-box ::v-deep .el-form-item { margin-bottom: 10px; }
    .operation-box { display: flex; justify-content: space-between; align-items: center; }
    .operation-left { display: flex; align-items: center; flex-wrap: wrap; }
    .op-tip { margin-left: 8px; color: #909399; font-size: 12px; }
    .filter-bar { margin-bottom: 4px; }
    .oname { font-weight: 600; color: #303133; }
    .tar { text-align: right; }
    .board-log ::v-deep .ec-reason .cell { white-space: normal; line-height: 1.6; color: #606266; }
    .board-log ::v-deep .header-cell { background: #e8eaec !important; color: #333 !important; }
</style>
